import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { DotsIcon, NoImagenIcon } from '../../../../images/icons/WrapSvg';

import Menu from './TableMenu';

function isOk(element, filter) {
    const { desechable, producible, estacion } = filter;
    let result = true;

    if (!desechable && !producible && !estacion) {
        return true;
    }

    if (desechable && element.incluirDesperdicio) {
        result = result && true;
    } else if (desechable) {
        result = result && false;
    }

    if (producible && element.producir) {
        result = result && true;
    } else if (producible) {
        result = result && false;
    }

    if (estacion && element.idEstacion.toString() === estacion.toString()) {
        result = result && true;
    } else if (estacion) {
        result = result && false;
    }

    return result;
}

class Index extends React.Component {
    state = {
        anchorEl: null,
        result: [],
        data: [],
        filtro: {},
    };

    static getDerivedStateFromProps(props, state) {
        if (
            props.data &&
            (props.data !== state.data ||
                props.search !== state.search ||
                props.filtro !== state.filtro)
        ) {
            const { data, search, filtro } = props;

            state.filtro = filtro ? filtro : {};
            state.data = data ? data : [];
            state.search = search ? search : [];
            state.result = []
                .concat(data)
                .sort((a, b) =>
                    a.nombre.toUpperCase().trim() < b.nombre.toUpperCase().trim() ? -1 : 1,
                )
                .reduce((arr, info) => {
                    if (search && search.length > 0) {
                        const filter = search.filter(
                            (s) => info.nombre && info.nombre.toUpperCase().includes(s),
                        );
                        if (filter && filter.length > 0 && isOk(info, filtro)) {
                            arr.push(info);
                        }
                    } else if (isOk(info, filtro)) {
                        arr.push(info);
                    }
                    return arr;
                }, []);

            return state;
        }
        return null;
    }

    handleClick = (event, id) => {
        this.setState({ anchorEl: event.currentTarget, id: id });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, id: null });
    };

    render() {
        const { intl } = this.props;
        const { anchorEl, id, result } = this.state;
        return (
            <Paper className={'products_table_paper bg_ice_blue'}>
                <Table className={'products_table_table'}>
                    <TableHead>
                        <TableRow className={'products_table_row'}>
                            <TableCell />
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'product_table_product' })}
                            </TableCell>
                            <TableCell
                                 align='right' 
                                className={'barlow_regular_small c_greyish_brown upper'}
                            >
                                {intl.formatMessage({ id: 'product_table_life' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'product_table_production' })}
                            </TableCell>
                            <TableCell className={'barlow_regular_small c_greyish_brown upper'}>
                                {intl.formatMessage({ id: 'product_table_workplace' })}
                            </TableCell>
                            <TableCell align='right' />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {result &&
                            result.length > 0 &&
                            result.map((n) => {
                                return (
                                    <TableRow
                                        hover
                                        key={n.id}
                                        className={'products_table_row hand'}
                                        classes={{ hover: 'products_table_hover' }}
                                    >
                                        <TableCell className={'center padding_0'} scope="row">
                                            {n.foto ? (
                                                <img
                                                    src={n.foto}
                                                    alt="Preview"
                                                    style={{ width: 40 }}
                                                />
                                            ) : (
                                                <NoImagenIcon />
                                            )}
                                        </TableCell>
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                            component="th"
                                            scope="row"
                                        >
                                            {n.nombre}
                                        </TableCell>
                                        <TableCell
                                             align='right' 
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                        >
                                            {n.tiempovida}
                                        </TableCell>
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                        >
                                            {n.nomUnidadesmedida}
                                        </TableCell>
                                        <TableCell
                                            className={'barlow_regular_small c_dark_grey_blue'}
                                        >
                                            {n.nomEstacion}
                                        </TableCell>
                                        <TableCell  align='right'  className={'products_table_dots'}>
                                            <Button
                                                size="small"
                                                color="primary"
                                                aria-label="add"
                                                className={'products_table_button'}
                                                onClick={(e) => this.handleClick(e, n.id)}
                                            >
                                                <DotsIcon />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
                {anchorEl && (
                    <Menu
                        anchorEl={anchorEl}
                        id={id}
                        handleClose={this.handleClose}
                        onError={this.props.onError}
                    />
                )}
            </Paper>
        );
    }
}

Index.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Index);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/products/Table.js